module.exports = __webpack_public_path__ + "static/media/desc.17716440.svg";